import React from "react";

export class DividerPadding extends React.Component {
    render() {
        return <div style={{ paddingTop: parseInt(this.props.top), paddingBottom: parseInt(this.props.bottom) }}></div>
    }
}